/**
 * This instance is part of an interceptor, rewriting all responses
 * to an instance with several useful methods
 */

(function () {
	angular
		.module('trackeye')
		.factory('ResponseXHR', _ResponseXHRFactory);

	_ResponseXHRFactory.$inject = [];

	function _ResponseXHRFactory() {

		/**
		 * @param data
		 * @constructor
		 */
		function ResponseXHR(data) {
			this.error = false;
			this.aborted = false;
			this.config = {};
			this.data = {};
			this.headers = angular.noop;
			this.status = 0;
			this.statusStr = "";
			this.statusText = "";

			if (data instanceof Error) {
				this.error = data;
				this.status = 406;
				this.statusStr = this.status.toString();
				this.statusText = "Internal Server Error";
			} else if (!data) {
				this.aborted = true;
			} else {
				this.config = data.config || {};
				this.data = data.data;
				this.headers = data.headers;
				this.status = parseInt(data.status, 10);
				this.statusStr = this.status.toString();
				this.statusText = data.statusText;
			}
		}

		ResponseXHR.prototype.getStatus = function () {
			return this.status;
		};

		ResponseXHR.prototype.getResponseData = function (prop) {
			if (prop)
				return this.data[prop];

			return this.data;
		};

		ResponseXHR.prototype.getRequestData = function () {
			return this.config.data || {};
		};

		ResponseXHR.prototype.getRequestMethod = function () {
			return this.config.method;
		};

		ResponseXHR.prototype.ignoreAuth = function () {
			return this.config.__ignore_auth;
		};

		ResponseXHR.prototype.ignoreErrors = function () {
			return this.config.__ignore_errors;
		};

		//
		// ASSERTIONS
		//

		ResponseXHR.prototype.isAborted = function () {
			return this.aborted;
		}

		/**
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.is40x = function () {
			return !!this.statusStr.match(/4\d{2}/);
		};

		/**
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.is50x = function () {
			return !!this.statusStr.match(/5\d{2}/);
		};

		/**
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.NoContent = function () {
			return this.status === 204;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.BadRequest = function () {
			return this.status === 400;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.Unautorized = function () {
			return this.status === 401;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.Forbidden = function () {
			return this.status === 403;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.NotFound = function () {
			return this.status === 404;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.NotAcceptable = function () {
			return this.status === 406;
		};

		ResponseXHR.prototype.Conflict = function () {
			return this.status === 409;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.UnprocessableEntity = function () {
			return this.status === 422;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.InternalServerError = function () {
			return this.status === 500;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.NotImplemented = function () {
			return this.status === 501;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.BadGateway = function () {
			return this.status === 502;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.ServiceUnavailable = function () {
			return this.status === 503;
		};

		/**
		 *
		 * @returns {boolean}
		 */
		ResponseXHR.prototype.GatewayTimeout = function () {
			return this.status === 504;
		};

		return ResponseXHR;
	}
})();